import { CircularProgress, Modal } from '@material-ui/core'
import {
  CheckCircle as CheckCircleIcon,
  ErrorOutline as ErrorOutlineIcon
} from '@material-ui/icons'

import { BulkGoalClasses, BulkGoalCreationResult } from '../../types'

interface CreationResultDialogProps {
  classes: BulkGoalClasses
  failedResults: BulkGoalCreationResult[]
  hasErrors: boolean
  isCreatingGoals: boolean
  open: boolean
  onClose: () => void
}

const CreationResultDialog = ({
  classes,
  failedResults,
  hasErrors,
  isCreatingGoals,
  open,
  onClose
}: CreationResultDialogProps) => {
  return (
    <Modal open={open} closeAfterTransition>
      <div className={classes.creationDialog}>
        <div className={classes.creationDialogIcon}>
          {isCreatingGoals ? (
            <CircularProgress size={34} />
          ) : hasErrors ? (
            <ErrorOutlineIcon style={{ color: '#d32f2f', fontSize: 38 }} />
          ) : (
            <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 38 }} />
          )}
        </div>

        <h2 className={classes.creationDialogTitle}>
          {isCreatingGoals
            ? 'Criando metas'
            : hasErrors
              ? 'Criação concluída com pendências'
              : 'Metas criadas com sucesso'}
        </h2>

        <p className={classes.creationDialogText}>
          {isCreatingGoals
            ? 'Não feche esta guia até concluirmos a criação das metas.'
            : hasErrors
              ? 'Não foi possível confirmar a criação de todas as metas. Confira no painel quais foram criadas e tente novamente para as lojas que continuarem sem meta.'
              : 'As metas foram criadas e já estão disponíveis no painel.'}
        </p>

        {!isCreatingGoals && hasErrors && (
          <ul className={classes.creationDialogErrors}>
            {failedResults.map(result => (
              <li className={classes.creationDialogErrorItem} key={result.storeId}>
                <strong>{result.storeName}</strong>
                {result.errorMessage || 'Não foi possível confirmar a criação da meta desta loja.'}
              </li>
            ))}
          </ul>
        )}

        {!isCreatingGoals && (
          <button className={classes.creationDialogButton} onClick={onClose} type='button'>
            Conferir metas no painel
          </button>
        )}
      </div>
    </Modal>
  )
}

export default CreationResultDialog
